import { SimpleGrid, SimpleGridProps } from 'components'
import { ScaleProps, useScaleProps } from '../../utils/scaleUtils'

export type Props = ScaleProps<SimpleGridProps>

export default function SGrid(props: Props) {
  const { styleProps, rest } = useScaleProps(props)
  return <SimpleGrid {...styleProps} {...rest} />
}
